
import { Share2, Users, Gift, Mail, Trophy } from 'lucide-react';
import { CampaignType } from '@/components/admin/campaigns/types';

export const campaignTypes: CampaignType[] = [
  {
    id: 'refer-a-friend',
    title: 'Refer a Friend',
    icon: Share2,
    description: 'Encourage users to invite friends to your platform. Both the referrer and the referred user receive a reward when the referred user completes a specific action.',
    setupSteps: [
      'Define trigger event (e.g., user signs up, user makes a purchase)',
      'Set rewards for both referrer and referred',
      'Enable unique referral links for users',
      'Add social sharing and email invite options',
      'Set tracking logic for referral validation',
      'Add notification system for successful referrals'
    ]
  },
  {
    id: 'affiliate-program',
    title: 'Affiliate Program',
    icon: Users,
    description: 'Empower partners or influencers to promote your business and earn commissions for referred sales.',
    setupSteps: [
      'Set commission rate (e.g., 10% per sale)',
      'Enable monthly payouts via PayPal or ACH',
      'Generate affiliate links with unique tracking IDs',
      'Upload marketing assets (banners, templates)',
      'Build reporting dashboard for affiliate performance',
      'Automate monthly summary emails for affiliates'
    ]
  },
  {
    id: 'milestone-giveaways',
    title: 'Milestone Giveaways',
    icon: Gift,
    description: 'Reward users for hitting referral goals. Ideal for driving volume by motivating users to refer more.',
    setupSteps: [
      'Define milestone thresholds (e.g., every 5 referrals)',
      'Assign tiered rewards per milestone',
      'Track cumulative referrals per user',
      'Design milestone progress tracker UI',
      'Set automation for milestone reward delivery',
      'Enable email alerts for milestone achievements'
    ]
  },
  {
    id: 'newsletter-referral',
    title: 'Newsletter Referral',
    icon: Mail,
    description: 'Turn your newsletter subscribers into referral champions. Grow your list through reward-driven signups.',
    setupSteps: [
      'Integrate with email platform (e.g., Mailchimp, Klaviyo)',
      'Create referral link in email footer or CTA',
      'Define reward rules (e.g., 1 reward per 3 referrals)',
      'Track new signups by referral link source',
      'Send confirmation emails upon successful referrals',
      'Add reward history to user profile (optional)'
    ]
  },
  {
    id: 'leaderboard',
    title: 'Leaderboard',
    icon: Trophy,
    description: 'Add competition to your referral program. Showcase top referrers and award grand prizes.',
    setupSteps: [
      'Build public or private leaderboard UI',
      'Rank users by total verified referrals',
      'Set reward rules for top positions (e.g., 1st place: $100 gift card)',
      'Add start/end dates for contest period',
      'Display real-time updates on user dashboard',
      'Automate prize announcements at contest close'
    ]
  }
];

